import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import Switch from "react-bootstrap-switch";
import * as Yup from "yup";
import { Col, Form, FormGroup, Input, Row, Spinner } from "reactstrap";
import { useForm } from "react-hook-form";
import Select from "react-select";

// components
import { ButtonCancel, ButtonSubmit } from "../../buttons/buttonsActions";

// labels
import {
    LB_ALLERGIES, LB_COMMENTS, LB_DATE, LB_DURATION, LB_HOUR, LB_PEOPLE, LB_REMINDER,
    LB_SHARE_CABINE, LB_TREATMENT, LB_WHAT_ALLERGIES, REQUIRED
} from "../../i18n/i18n";

// services
import { placeProvider } from "../../../providers/placeProvider";

import { dishDrinkProvider } from "../../../providers/ayb/dishDrinkProvider";

// actions
import { add } from "../../../redux/actions/todoFluye/wishlistActions";

// utils
import { formatStringDate } from "../../../util/DateTools";
import { wishlistTypes } from "../../../util/WishlistUtils";

const SpaFormComponent = props => {
    const fbDataBaseId = props.mainState?.app?.fbDataBase?.id
    const udn =  JSON.parse( localStorage.getItem('selectedUdn') )

    const { domainObject } = props.formState
    const { wishlist, handleCancel, handleToggle  } = props

    const [ editMode ] = useState(domainObject != null)
    const [shareCabin, setShareCabin] = useState(domainObject?.shareCabin || false)

    const [places, setPlaces] = useState([])
    const [place, setPlace] = useState()
    const [loadingPlaces, setLoadingPlaces] = useState(true)
    const [loadedDefaultPlace, setLoadedDefaultPlace] = useState(false)
    const [placeError, setPlaceError] = useState(false)

    const [treatments, setTreatments] = useState([])
    const [treatment, setTreatment] = useState()
    const [loadingTreatments, setLoadingTreatments] = useState(true)
    const [loadedDefaultTreatment, setLoadedDefaultTreatment] = useState(false)
    const [treatmentError, setTreatmentError] = useState( false )

    const [prices, setPrices] = useState([])
    const [price, setPrice] = useState( domainObject?.treatmentPrice )
    const [loadingPrices, setLoadingPrices] = useState(false)
    const [loadedDefaultPrice, setLoadedDefaultPrice] = useState(false)

    const [ reminder, setReminder ] = useState( domainObject?.reminder || false )


    // load places
    useEffect(()=> {
        const requestData = {
            code:'xpa',
            udn:{ id: udn?.id}
        }

        setLoadingPlaces(true)

        placeProvider.getOptions( requestData )
            .then( setPlaces )
            .finally(() => setLoadingPlaces(false) )
    },[])

    // load treatments
    useEffect(()=>{
        if(!place){
            setTreatment(null)
            setTreatments([])
            setLoadingTreatments( false )

            return
        }

        setPlaceError(false)

        const requestData = {
            fbDataBaseId,
            item: {
                place: place?.id
            }
        }

        setLoadingTreatments(true)

        dishDrinkProvider.getOptions( requestData )
            .then( setTreatments )
            .finally( () => setLoadingTreatments(false) )
    }, [ place ])

    // load prices
    useEffect(() => {
        if(!treatment)
            return

        const requesData = {  id: treatment?.id }

        setLoadingPrices( true )

        dishDrinkProvider.getPricesOptions( requesData )
            .then( setPrices )
            .finally( () => setLoadingPrices(false )  )
    }, [ treatment ])

    // load default data
    useEffect(()=>{
        if(!domainObject)
            return

        if(!loadedDefaultPlace && places.length >0){
            const defaultPlace = places.find( i => i.id === domainObject?.place?.id)
            setPlace(defaultPlace)
            setLoadedDefaultPlace(true)
        }

        if(!loadedDefaultTreatment && treatments.length > 0){
            const defaultTreatment = treatments.find( i => i.id === domainObject?.treatment?.id)
            setTreatment(defaultTreatment)
            setLoadedDefaultTreatment(true)
        }

        if(!loadedDefaultPrice && prices.length > 0){
            const defaultPrice = prices.find( i => i?.id === domainObject?.treatmentPrice?.id)
            setPrice(defaultPrice)
            setLoadedDefaultPrice( true )
        }
    },[places, treatments, prices])

    const validationSchema = Yup.object().shape({
        date: Yup.string().required( REQUIRED ),
        hour: Yup.string().required( REQUIRED ),
        pax: Yup.string().required( REQUIRED ),
    });

    const { register, handleSubmit, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues:{
            date: domainObject ? formatStringDate(domainObject?.date) : null,
            hour: domainObject?.hour,
            pax: domainObject?.pax,
            allergic: domainObject?.allergic,
            allergies: domainObject?.allergies,
            comments: domainObject?.comments,
            confirmationCode: domainObject?.confirmationCode,
        }
    });

    const onSubmit = (data, _) => {
        if(!place){
            setPlaceError(true)
            return
        }

        if(!treatment){
            setTreatmentError(true)
            return
        }

        let dataRequest = {
            fbDataBase: fbDataBaseId,
            item: {
                ... data,
                type: wishlistTypes.spa.description,
                shareCabin,
                from:'wishlist',
                reminder,
                wishlist:{ id: wishlist?.id },
                treatment: { id: treatment?.id },
                treatmentPrice: { id: price?.id },
                place: { id: place?.id }
            }
        }

        if(domainObject)
            dataRequest.item.id = domainObject?.id

        props.add( dataRequest, handleToggle )
    }


    const onSpaChange = val => {
        setPlace(val)
        setTreatments([])
        setTreatment(null)
        setPrices([])
        setPrice(null)
    }

    const onTreatmentChange = val => {
        setTreatment(val)
        setPrices([])
        setPrice(null)
    }

    return <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className={'mb-1em'}>
            <Col className={'wl-modal-title-item'}>
                <img
                    src={require(`../../../assets/images/wishlist/${props?.selectedOption?.icon}`)}
                    alt={props?.selectedOption?.title}
                    width={36}
                    height={36}
                /> &nbsp; { props?.selectedOption?.title }
            </Col>
            <Col>
                <FormGroup>
                    {
                        loadingPlaces ?  <> <Spinner animation="border" /> </> : <Select
                            value={ place }
                            options={ places }
                            isClearable={ true }
                            onChange={ val => onSpaChange(val) }
                            isDisabled = {editMode}
                            styles={{ }}
                        />
                    }
                    { placeError && <div className="invalid-feedback" style={{'display':'block'}}>{ REQUIRED }</div>}
                </FormGroup>
            </Col>
        </Row>

        <Row className={'mb-1em'}>
            <Col>
                <FormGroup>
                    <label>
                        <i className={ 'fa fa-calendar' } aria-hidden='true' /> &nbsp;{ LB_DATE }
                    </label>
                    <Input
                        name='date'
                        type='date'
                        /*min={ getDateToFormField(wishlist?.checkIn) }
                        max={ getDateToFormField(wishlist?.checkOut) }*/
                        innerRef={register}
                    />
                    { errors?.date && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.date?.message}</div>}
                </FormGroup>
            </Col>
            <Col>
                <label>
                    <i className={ 'fa fa-clock' } aria-hidden='true' /> &nbsp;{ LB_HOUR }
                </label>
                <FormGroup>
                    <Input
                        name='hour'
                        type="time"
                        innerRef={register}
                    />
                    { errors?.hour && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.hour?.message}</div>}
                </FormGroup>
            </Col>
            <Col>
                <FormGroup>
                    <label>
                        <i className={ 'fa fa-users' } aria-hidden='true' /> &nbsp;{ LB_PEOPLE }
                    </label>
                    <Input
                        name='pax'
                        type='number'
                        innerRef={register}
                    />
                    { errors?.pax && <div className="invalid-feedback" style={{'display':'block'}}>{ errors?.pax?.message }</div>}
                </FormGroup>
            </Col>
        </Row>

        <Row className={'mb-1em'}>
            <Col>
                <FormGroup>
                    <label>{LB_TREATMENT}</label>
                    <br/>
                    {
                        (loadingTreatments || loadingPlaces) ?  <> <Spinner animation="border" /> </> : <Select
                            value={ treatment }
                            options={ treatments }
                            isClearable={ true }
                            onChange={ val => onTreatmentChange(val) }
                            styles={{ }}
                        />
                    }
                    { treatmentError && <div className="invalid-feedback" style={{'display':'block'}}>{ REQUIRED }</div>}
                </FormGroup>
            </Col>
            <Col>
                <FormGroup>
                    <label>{ LB_ALLERGIES }</label>
                    <Input
                        name='allergic'
                        type='number'
                        innerRef={register}
                    />
                    { errors?.allergic && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.allergic?.message}</div>}
                </FormGroup>
            </Col>
        </Row>

        <Row className={'mb-1em'}>
            <Col>
                <label>{ LB_WHAT_ALLERGIES }</label>
                <FormGroup>
                    <Input
                        name='allergies'
                        type="textarea"
                        innerRef={register}
                    />
                    { errors?.allergies && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.allergies?.message}</div>}
                </FormGroup>
            </Col>
        </Row>

        <Row className={'mb-1em'}>
            <Col>
                <FormGroup>
                    <label>{LB_DURATION}</label>
                    <br/>
                    {
                        (loadingPrices || loadingTreatments) ?  <> <Spinner animation="border" /> </> : <Select
                            value={ price }
                            options={ prices }
                            isClearable={ true }
                            onChange={ val => setPrice(val) }
                            styles={{ }}
                        />
                    }
                    { treatmentError && <div className="invalid-feedback" style={{'display':'block'}}>{ REQUIRED }</div>}
                </FormGroup>
            </Col>
            <Col>
                <FormGroup>
                    <label>{ LB_SHARE_CABINE }</label><br/>
                    <Switch
                        animate={true}
                        offText={"No"}
                        onText={"Si"}
                        value={ shareCabin }
                        onChange={ () => setShareCabin(!shareCabin) }
                    />
                </FormGroup>
            </Col>
            <Col>
                <FormGroup>
                    <label>{ LB_REMINDER }</label><br/>
                    <Switch
                        animate={true}
                        offText={"No"}
                        onText={"Si"}
                        value={ reminder }
                        onChange={ () => setReminder(!reminder) }
                    />
                </FormGroup>
            </Col>
        </Row>

        <Row className={'mb-1em'}>
            <Col>
                <label>{ LB_COMMENTS }</label>
                <FormGroup>
                    <Input
                        name='comments'
                        type="textarea"
                        innerRef={register}
                    />
                </FormGroup>
            </Col>
        </Row>

        <Row>
            <Col className="d-flex justify-content-center">
                <div>
                    <ButtonSubmit/>
                    <ButtonCancel onClick={ ()=> handleCancel() }/>
                </div>
            </Col>
        </Row>
    </Form>
}

const mapStateToProps = state => ({
    mainState: state.mainProps,
    formState: state.formProps
})
const mapActionsToProps = ({
    add
})

export default connect(mapStateToProps, mapActionsToProps)(SpaFormComponent)